import type { NDateLocale } from './enUS'
import { pl } from 'date-fns/locale'

const datePlPL: NDateLocale = {
  name: 'pl-PL',
  locale: pl
}

export default datePlPL
